exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".otp .resend-otp{color:#F58220;font-weight:bold;margin-left:2px}.otp .resend-otp:hover{cursor:pointer}\n", ""]);

